(function($) {
  function _get_param(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  Drupal.behaviors.slideComparison = {

    attachCustom: function($templates) {
      var hotspot_debug = _get_param('hotspot') != null;
      $templates.each(function(i, obj) {
        var $template = $(obj);
        $template.addClass('enabled');
        var $image_container = $('.slide-comparison__img', $template);
        var $hotspots = $('.hotspot', $template);
        var __interacted = false;
        var __revealed = false;
        var __first_revealed = false;
        var __animating = false;
        var __revealing = false;
        var __hiding = false;
        var __target_state = null;
        $hotspots.addClass('no-animate');

        var __first_swipe_direction = $template.data('first-swipe-direction');
        if (!__first_swipe_direction) {
          __first_swipe_direction = 'left';
        }
        var __starting_position = $template.data('starting-position');
        if (!__starting_position) {
          __starting_position = 50;
        }
        // convert to decimal
        __starting_position = __starting_position / 100;

        var __hide_speed = $template.data('hide-speed');
        if (!__hide_speed) {
          __hide_speed = 500;
        }

        var __reveal_speed = $template.data('reveal-speed');
        if (!__reveal_speed) {
          __reveal_speed = 500;
        }

        var __first_slide_speed = $template.data('first-slide-speed');
        if (!__first_slide_speed) {
          __first_slide_speed = 1500;
        }

        function inViewport($elem) {
          var elementTop = $elem.offset().top;
          var elementBottom = elementTop + $elem.outerHeight(false);
          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).innerHeight;

          var fullyContained = elementTop > viewportTop && elementBottom < viewportBottom;
          var coversViewport = elementBottom > viewportBottom && elementTop < viewportTop;

          return fullyContained || coversViewport;
        }

        var reveal_hotspots = function(no_animation) {
          // already revealing
          if (__animating === 'reveal') {
            return;
          }
          // already revealed.
          if (__animating === false && __revealed) {
            return;
          }
          __animating = 'reveal';
          __target_state = 'reveal';
          // sequentially call fadein
          var complete = $hotspots.toArray().map(function(e) {
            return function() {
              if (__target_state === 'hide') {
                return;
              }
              return $(e).fadeIn(__reveal_speed).promise();
            };
          }).reduce(function(cur, next) {
            return cur.then(next);
          }, $().promise());

          complete.then(function() {
            __animating = false;
            __revealed = true;
          }).then(function() {
            window.setTimeout(function() {
              // hack to sync gpu animations
              $hotspots.removeClass('no-animate');
            }, __reveal_speed);
          });
        };

        var hide_hotspots = function() {
          // already hiding
          if (__animating === 'hide') {
            return;
          }
          // already hidden
          if (__animating === false && !__revealed) {
            return;
          }
          __animating = 'hide';
          __target_state = 'hide';
          $hotspots.fadeOut(__hide_speed, function() {
            __animating = false;
            __revealed = false;
            $hotspots.addClass('no-animate');
          });
        };

        var move_slider = function(percentageDecimal) {
          var event = new CustomEvent(
            'moveSlide',
            {
              detail: {
                left: percentageDecimal,
                fake: true,
              }
            }
          );
          $template[0].dispatchEvent(event);
        };

        var __animating_move = false;
        var animate_move = function(current_val, new_val, duration, complete_callback) {
          __animating_move = $({val: current_val}).animate(
            {val: new_val},
            {
              duration: duration,
              step: function(now) {
                move_slider(now);
              },
              complete: function() {
                __animating_move = false;
                if (complete_callback) {
                  complete_callback();
                }
              }
            });
        };

        var stop_move = function() {
          __animating_move.stop();
          __animating_move = false;
        };

        var turn_1 = 1;
        var turn_2 = .001;
        if (__first_swipe_direction === 'right') {
          turn_1 = .001;
          turn_2 = 1;
        }
        if (__first_swipe_direction === 'none') {
          turn_1 = __starting_position;
        }

        // reveal hotspots sequentially once
        var process_first_reveal = function() {
          if (__first_revealed) {
            return;
          }
          if (!inViewport($image_container)) {
            return;
          }

          if ($template.hasClass('interacted')) {
            return;
          }

          if (__first_swipe_direction === 'none') {
            move_slider(__starting_position);
            reveal_hotspots();
            return;
          }

          move_slider(turn_1);

          animate_move(turn_1, turn_2, __first_slide_speed, function() {
            animate_move(turn_2, __starting_position, __first_slide_speed, reveal_hotspots);
          });
          __first_revealed = true;
        };

        // if debug is on. only show after and no animations
        if (hotspot_debug) {
          $hotspots.show();
          $template.addClass('disable-mouseover');
          move_slider(0);
          return;
        }

        // default slider to it's first turn.
        move_slider(turn_1);

        $(window).on('scroll resize', _.debounce(process_first_reveal, 300));
        process_first_reveal();

        $template.on('moveSlide', function(e) {
          $template.addClass('interacted');
          __interacted = true;
          // we are genearting. let it go
          if (e.originalEvent.detail.fake) {
            return;
          }

          if (__animating_move) {
            stop_move();
          }

          var percentage = e.originalEvent.detail.left;
          // When we mostly swiped after into full view.
          if (percentage < 0.1) {
            reveal_hotspots();
          } else {
            hide_hotspots();
          }
        });
      });
    },

    attach: function(context) {
      var $templates = $('.slide-comparison', context);
      var self = this;

      // Call the base lib
      window.imageComparisonSliderAttach($templates.toArray());
      // Add a delay to let the base lib finish
      self.attachCustom($templates);
    },
  };
})(jQuery);
